import React from "react";
import classNames from "classnames";
import "./index.scss";

import {ModalPopup} from "../ModalPopup/ModalPopup";
import DateRangePicker from "../DateRangePicker/index.js";

const DateRangePickerPopup = ({
    isOpen,
    onClose,
    systemLanguage,
    defaultStartDate,
    defaultEndDate,
    disableDateBefore
}) => {
    return (
        <ModalPopup
            isOpen={isOpen}
            onClose={onClose}
            width={'621px'}
            content={
                <div className={classNames("dateRangePickerPopup")}>
                    <DateRangePicker
                      systemLanguage={systemLanguage}
                      tab={1}
                      defaultStartDate={defaultStartDate}
                      defaultEndDate={defaultEndDate}
                      isOpen={true}
                      isShowCancelButton={true}
                      onClose={onClose}
                      disableDateBefore={disableDateBefore}
                    />
                </div>
            }
            height={"460px"}
            containerModalClass={"dateTimePickerPopupWrapper"}
        />
    );
}

export default DateRangePickerPopup;
